<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-05 17:55:59
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-11 14:23:59
 * @FilePath: \zhucai_user\src\pages\course\child\rightSide.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <dl v-loading="isLoading" class="width340">
    <dt
      class="BGwhite size16 radius8 gray1 flex pad22 b500 height60px flex between dtTitle mb1"
    >
      最新报名通知
    </dt>
    <div v-if="list.length > 0">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="activityInfo"
        @click="toDetail(item)"
      >
        <div class="content">
          {{ item.Title }}
        </div>
        <div class="Prop">
          <span class="PropName">报名起止日期：</span
          ><span class="PropValue time">{{ item.EnrollTime }}</span>
        </div>
      </div>
    </div>
    <div v-else class="info">
      <el-empty description="暂无内容" :image="empty1" />
    </div>
  </dl>
</template>

<script>
import { Enroll_GetList } from "@/api/apipcEnroll";
export default {
  name: "demo",
  data() {
    return {
      list: [],
      isLoading: false,
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    toDetail(item) {
      this.$router.push({
        path: "/apipcEnrollDetail",
        query: { SubjectID: item.SubjectID },
      });
    },

    getDetail() {
      this.isLoading = true;
      Enroll_GetList({
        PageIndex: 1,
        PageSize: 5,
      })
        .then((res) => {
          this.isLoading = false;
          this.list = res.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.width340 {
  width: 340px;
}
.dtTitle {
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: 24px;
    left: 0;
    width: 6px;
    height: 20px;
    background: #1d79ff;
    border-radius: 3px;
  }
}
.jiantou {
  .btn {
    cursor: pointer;
    margin-top: -5px;
    width: 28px;
    height: 28px;
  }
}
.activityInfo {
  cursor: pointer;
  padding: 15px;
  margin-bottom: 10px;
  background: #ffffff;
  border-radius: 10px;
  .content {
    font-size: 20px;
    color: #333333;
    display: -webkit-box;
    overflow: hidden; /* 超出的文本隐藏 */
    text-overflow: ellipsis; /* 溢出用省略号显示 */
    -webkit-box-orient: vertical; /* 垂直排列子元素 */
    -webkit-line-clamp: 2; /* 显示的行数 */
    margin-bottom: 10px;
  }
  .Prop {
    .PropName {
      font-size: 16px;
      color: #999999;
    }
    .PropValue {
      font-size: 16px;
      color: #333333;
    }
    .time {
      color: #1d79ff;
      font-weight: bold;
    }
  }
}
</style>
